import classNames from 'classnames';
import { ComponentProps } from 'react';

import CleanLinkButton from '../../../../../components/CleanLinkButton/CleanLinkButton';

import styles from './TintOnHoverButton.module.css';

type TintOnHoverLinkButtonProps = ComponentProps<typeof CleanLinkButton> & {
    hovering?: boolean;
    borderRadiusSize?: 'regular' | 'large';
    borderRadius?: 'all' | 'top' | 'bottom' | 'none' | 'left' | 'right';
};

const TintOnHoverLinkButton = ({
    className,
    hovering,
    borderRadius = 'none',
    borderRadiusSize = 'regular',
    ...props
}: TintOnHoverLinkButtonProps) => {
    const classes = classNames(className, styles.Root, {
        [styles.hovering]: hovering,
        [styles.borderRadiusBoth]: borderRadius === 'all',
        [styles.borderRadiusTop]: borderRadius === 'top',
        [styles.borderRadiusBottom]: borderRadius === 'bottom',
        [styles.borderRadiusLeft]: borderRadius === 'left',
        [styles.borderRadiusRight]: borderRadius === 'right',
        [styles.borderRadiusSizeLarge]: borderRadiusSize === 'large',
    });

    return <CleanLinkButton {...props} className={classes} />;
};

export default TintOnHoverLinkButton;
